import { Component } from '@angular/core';
import { TimeHelperUtils } from 'angular/utils/time-helper.utils';
import { SortDirection } from 'angular/utils/common-types';
import { FilterPipe } from 'angular/custom/pipes/filter.pipe';
import { SortPipe } from 'angular/custom/pipes/sort.pipe';
import {
    MultiYearAuctionsResource,
    MultiYearCfoAuctionGuiDto
} from 'angular/resources/multi-year-auctions.resource';
import { PagingSetting } from 'app/custom';
import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandlerService } from 'angular/custom/services/error-handler.service';

@Component({
    selector: 'pkp-multi-year-capacity',
    template: require('./multi-year-capacity.component.html'),
    preserveWhitespaces: true
})
export class MultiYearCapacityComponent {
    public isLoading: boolean = true;
    public countdown: CountDown;
    public pagingSetting: PagingSetting = <PagingSetting>{};
    public pageNumber = 1;

    public range: {
        lower: number;
        upper: number;
    } = {
        lower: 0,
        upper: 10
    };

    public filterSettings: {
        active: boolean;
        filters: { [column: string]: string };
    } = {
        active: false,
        filters: {}
    };

    public sortSettings: {
        column?: string;
        order?: SortDirection;
    } = {};

    public sortDir = SortDirection;

    public filterPipe = new FilterPipe();
    public sortPipe = new SortPipe();
    public _filteredAuctions: MultiYearCfoAuctionGuiDto[] = [];

    public auctions: MultiYearCfoAuctionGuiDto[] = [];

    constructor(
        private multiYearAuctionResource: MultiYearAuctionsResource,
        private growl: Growl,
        private errorHandlerService: ErrorHandlerService
    ) {}

    public loadAuctions() {
        this.isLoading = true;
        this.multiYearAuctionResource.getAuctions().subscribe(
            (auctions) => {
                this.auctions = auctions;
                this.applyFiltering();
                this.applyPagination();
                this.isLoading = false;
                if (this.auctions.length > 0) {
                    this.countdown = {
                        targetTime: auctions[0].submissionWindow.end, // hack as all will have the same
                        type: 'AUCTION_CLOSE'
                    };
                }
            },
            (err) =>
                this.errorHandlerService.handle(
                    err,
                    'Available auctions could not be loaded.'
                )
        );
    }

    public applyPagination() {
        this.range.lower = Math.max(
            this.pagingSetting.pageSize * (this.pageNumber - 1),
            0
        );
        if (this.range.lower >= this.filteredAuctions.length) {
            // go to last available page
            this.pageNumber = Math.max(
                Math.ceil(
                    this.filteredAuctions.length / this.pagingSetting.pageSize
                ),
                1
            );
            this.range.lower = Math.max(
                this.pagingSetting.pageSize * (this.pageNumber - 1),
                0
            );
        }
        this.range.upper = Math.min(
            this.pagingSetting.pageSize * this.pageNumber,
            this.filteredAuctions.length
        );
        this.pagingSetting = Object.assign({}, this.pagingSetting);
    }

    public applyFiltering() {
        const filtered = this.filterPipe.transform(
            this.auctions,
            this.filterSettings
        );
        this._filteredAuctions = this.sortPipe.transform(
            filtered,
            this.sortSettings
        );
    }

    public changeSortOrder(columnName: string) {
        if (this.sortSettings.column === columnName) {
            if (this.sortSettings.order === SortDirection.DESC) {
                this.sortSettings.order = SortDirection.ASC;
            } else if (this.sortSettings.order === SortDirection.ASC) {
                this.sortSettings.order = SortDirection.NONE;
            } else if (this.sortSettings.order === SortDirection.NONE) {
                this.sortSettings.order = SortDirection.DESC;
            }
        } else {
            this.sortSettings.column = columnName;
            this.sortSettings.order = SortDirection.DESC;
        }
        this.sortSettings = Object.assign({}, this.sortSettings);
        this.applyFiltering();
    }

    public getSortDirection(column: string) {
        if (this.sortSettings.column === column) {
            return this.sortSettings.order;
        }
        return SortDirection.NONE;
    }

    public onFilterTextChanged() {
        this.filterSettings = Object.assign({}, this.filterSettings); // update object to trigger angular change detection
        this.applyFiltering();
        this.applyPagination();
    }

    public get filteredAuctions(): MultiYearCfoAuctionGuiDto[] {
        return this._filteredAuctions;
    }

    public toggleFilter() {
        this.filterSettings.active = !this.filterSettings.active;
        this.applyFiltering();
        this.applyPagination();
    }

    public isSubmissionAlreadyOpen(date: Date) {
        return date.valueOf() < new Date().valueOf();
    }
}
